<template>
  <div class="cardRecharge">
    <div class="header">
      <div class="cardNo-title">
        <div class="cardNo-label">储值卡号:</div>
        <div class="cardNo">{{ cardInfo.prepaidCardCode }}</div>
      </div>
    </div>
    <div class="main">
      <div class="title">储值卡充值</div>
      <div class="recharge">
        <div class="text">充值金额</div>
        <div class="amount">
          <van-field
            class="amtInpt"
            v-model="rechargeAmt"
            clearable
            label="￥"
            autofocus
            label-width="120"
            label-align="right"
            right-icon="edit"
            maxlength="5"
            type="number"
          />
        </div>
        <div class="remark">输入充值金额</div>
      </div>
      <van-divider
        :style="{
          color: '#E4E4E4',
          borderColor: '#E4E4E4',
          padding: '20px 16px 0 16px',
        }"
      />
      <div class="rechargeActive">
        <div class="activeTitle">多充多送</div>
        <div class="activeList">
          <div
            class=" "
            v-bind:class="[
              item.id == quickRechargeId ? 'active' : '',
              'activeItem',
            ]"
            v-for="(item, idx) in rechargeRules"
            v-bind:key="idx"
            v-on:click="toRecharge(item)"
          >
            <div class="select">
              <van-icon name="success" class="badge-icon" />
            </div>
            <div class="rechAmt">￥ {{ item.ranchageAmount }}</div>
            <div class="giftAmt">- 赠送{{ item.creditAmount }}元 -</div>
          </div>
        </div>
        <div></div>
        <div></div>
      </div>
      <div class="rechbtn">
        <van-button
          type="primary"
          v-on:click="toRecharge()"
          style="width: 300px"
          color="#C39C71"
          :disabled="rechargeDisable"
          >确认充值</van-button
        >
      </div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <van-dialog
      title="收款码"
      class="qrcode-dialog"
      v-model="showDialog"
      showCancelButton
      :showConfirmButton="false"
      overlay
      @closed="closeTimer"
    >
      <van-tabs style="margin-top: 10px" type="card" color="#C39C71">
        <van-tab title="微信">
          <div class="content">
            <div class="cardno">储值卡号: {{ cardInfo.prepaidCardCode }}</div>
            <div class="rechAmt">充值金额: {{ payAmt }}</div>
            <div class="qrcode" ref="weixinQrcode">
              <img :src="weixinQrCode" />
            </div>
          </div>
        </van-tab>
        <van-tab title="支付宝">
          <div class="content">
            <div class="cardno">储值卡号: {{ cardInfo.prepaidCardCode }}</div>
            <div class="rechAmt">充值金额: {{ payAmt }}</div>
            <div class="qrcode" ref="aliQrcode">
              <img :src="aliQrCode" />
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </van-dialog>
  </div>
</template>

<script>
import "../../assets/css/cardRecharge.less";
import {
  getCardInfo,
  findRechargeRules,
  getWeixinPayQrcode,
  getAliPayQrcode,
} from "@/api/card";
import { queryPost } from "@/api/common";
import QRCode from "qrcode";
export default {
  name: "CardRecharge",
  data() {
    return {
      showDialog: false, //是否显示充值弹窗
      cardInfo: "", //储值卡信息
      rechargeAmt: "", //输入的充值金额
      rechargeRules: "", //充值活动规则
      quickRechargeId: "", //快速充值ID
      payAmt: "", //实际充值金额
      shopInfo: "", //店铺信息
      weixinQrCode: "", //微信支付二维码
      aliQrCode: "", //支付宝支付二维码
      timer: false, //是否开启定时器
      timerCount: 0, //定时器计数器 ,每个支付最多查询300次
      maxTimerCount: 300, //最大计数数量
      rechargeDisable: true, //是否可以点击充值按钮
      outTradeNo: "",
      userInfo: "",
    };
  },
  components: {},
  created() {
    this.loadComments();
    this.loadCard();
    this.loadRechargeRule();
    this.loadMember();
  },
  computed: {},
  watch: {
    rechargeAmt: function (val) {
      if (val == "" || val == undefined || val <= 0 || val == "-") {
        this.rechargeDisable = true;
      } else {
        this.rechargeDisable = false;
      }
    },
  },
  //页面销毁前关闭定时任务
  beforeDestroy() {
    this.timer = false;
  },
  methods: {
    loadComments() {
      // debugger
      let s = sessionStorage.getItem("shopInfo");
      let c = sessionStorage.getItem("cardInfo");
      this.shopInfo = s ? JSON.parse(s) : "";
      this.cardInfo = c ? JSON.parse(c) : "";

      let r = sessionStorage.getItem("payResult");
      let payResult = r ? JSON.parse(r) : "";
      if (payResult != null && payResult != "" && payResult.rebuild) {
        this.payAmt = payResult.payAmt;
        this.showDialog = true;
        this.rechargeToCard();
      }
      let wxcode = sessionStorage.getItem("wxcode");
      let alicode = sessionStorage.getItem("alicode");
      if (wxcode) {
        this.weixinQrCode = wxcode;
      }
      if (alicode) {
        this.aliQrCode = alicode;
      }
    },
    //加载member
    loadMember() {
      let url = "/api/mbrinfo/findByMobile";
      let params = {
        mobile: this.cardInfo.tel,
      };
      queryPost(url, params)
        .then((resp) => {
          let _data = resp.data;
          if (_data.code == "0000") {
            this.userInfo = _data.data.results;
          } else {
            this.$toast.fail(_data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //加载充值活动列表
    loadRechargeRule() {
      findRechargeRules().then((resp) => {
        let _data = resp.data;
        if (_data.code == "0000") {
          this.rechargeRules = _data.data.results;
        } else {
          this.$toast.fail(_data.msg);
        }
      });
    },
    //加载储值卡资料
    loadCard() {
      getCardInfo(this.cardInfo.prepaidCardCode)
        .then((resp) => {
          let _data = resp.data;
          if (_data.code == "0000") {
            let cardLists = _data.data.results.valueCardVosl;
            if (cardLists == null || cardLists.length == 0) {
              this.$toast.fail("该储值卡已销毁");
            } else {
              this.cardInfo = cardLists[0];
            }
          } else {
            this.$toast.fail(_data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //TODO 前往充值
    toRecharge(item) {
      if (item == null || item == undefined) {
        this.quickRechargeId = "";
        this.payAmt = this.rechargeAmt;
      } else {
        this.rechargeAmt = "";
        this.quickRechargeId = item.id;
        this.payAmt = item.ranchageAmount;
      }
      this.chanageShowDialog();
    },
    //显示充值二维码
    chanageShowDialog() {
      this.showDialog = !this.showDialog;
      this.rechargeToCard();
    },
    //点击充值事件
    rechargeToCard() {
      if (
        this.payAmt == "" ||
        this.payAmt == undefined ||
        this.payAmt <= 0 ||
        this.payAmt == "-"
      ) {
        return;
      }
      let weiXinPayReqVo = {
        amount: this.payAmt,
        clerkId: this.shopInfo.id,
        clerkOpenId: "",
        shopId: this.shopInfo.shopCode,
        userId: this.userInfo.id,
        type: 0,
        userMobile: this.cardInfo.tel,
        valueCardNo: this.cardInfo.prepaidCardCode,
        storeId: this.shopInfo.id,
      };

      //获取微信支付二维码
      getWeixinPayQrcode(weiXinPayReqVo).then((resp) => {
        // debugger
        let _data = resp.data;
        if (_data.code == "0000") {
          let url = _data.data.results.codeUrl;
          this.outTradeNo = _data.data.results.outTradeNo;
          //生成二维码
          QRCode.toDataURL(url).then((url) => {
            this.weixinQrCode = url;
            sessionStorage.setItem("wxcode", url);
          });
          weiXinPayReqVo.orderId = _data.data.results.outTradeNo;
          getAliPayQrcode(weiXinPayReqVo).then((resp) => {
            // debugger
            let _data = resp.data;
            if (_data.code == "0000") {
              let url = _data.data.results.payCode;
              //生成二维码
              QRCode.toDataURL(url).then((url) => {
                sessionStorage.setItem("alicode", url);
                this.aliQrCode = url;
              });
            }
          });
          this.timer = true;
          this.timerCount = 0; //初始化计时器
          this.timerStart(); //开启定时器，查询支付结果
        } else {
          this.$toast.fail(_data.msg);
        }
      });
    },
    //获取支付结果
    getPayResult() {
      // let _this = this;
      let url = "/api/rechargeorder/getStatusByName";
      let data = {
        orderNo: this.outTradeNo,
      };
      queryPost(url, data).then((resp) => {
        let _data = resp.data;
        if (_data.code == "0000" && _data.data.results.payStatus == 1) {
          this.timer = false;
          this.showDialog = false;
          let payResult = {
            success: true,
            payAmt: this.payAmt,
            data: _data.data.results,
          };
          sessionStorage.setItem("payResult", JSON.stringify(payResult));
          this.$router.push("rechargeResult"); //成功跳转
        }
      });
    },
    //开启定时任务的方法，为了定时查询支付结果，以便后续页面跳转
    timerStart() {
      var _this = this;
      _this.checkPayResult = window.setInterval(() => {
        setTimeout(_this.timerEnd(), 0);
      }, 1000);
    },
    //定时任务开关控制器
    timerEnd() {
      if (this.timerCount > this.maxTimerCount) {
        let payResult = {
          success: false,
          payAmt: this.payAmt,
        };
        sessionStorage.setItem("payResult", JSON.stringify(payResult));
        this.$router.push("rechargeResult"); //成功跳转
      }
      //超过尝试上限后,提示失败
      if (this.timer && this.timerCount <= this.maxTimerCount) {
        this.getPayResult();
        this.timerCount = this.timerCount + 1;
      } else {
        window.clearInterval(this.checkPayResult);
      }
    },
    //关闭定时任务
    closeTimer() {
      this.timer = false;
    },
  },
};
</script>


